import React from "react";
//#region types
import { WeekDateSummaryProps } from "models/propTypes/timeReportingPropTypes";
import { DateConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const WeekDateRange: React.FC<WeekDateSummaryProps> = (props) => {
  const { start, end } = props;
  return (
    <Grid container direction="column">
      <Grid item>
        {start.getMonth() !== end.getMonth()
          ? `${start.getDate()} ${LocalizationHelperInstance.getFormattedDate(
              start,
              DateConstants.MonthShortConfig
            )} – ${end.getDate()} ${LocalizationHelperInstance.getFormattedDate(end, DateConstants.MonthShortConfig)}`
          : `${start.getDate()} – ${end.getDate()} ${LocalizationHelperInstance.getFormattedDate(
              end,
              DateConstants.MonthLongConfig
            )}`}
      </Grid>
      <Grid item className={cssExports.titleCaption}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.WeekNumber, "", {
          weekNumber: DateHelper.getWeekNumber(start),
        })}
      </Grid>
    </Grid>
  );
};

export default WeekDateRange;
